"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const recaptcha_1 = require("./recaptcha");
const ID = "turnstile-con";
class Turnstile extends recaptcha_1.default {
    constructor(key) {
        super({
            src: "https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback",
            key,
        });
        this.instanceID = 0;
        this.widgetID = undefined;
    }
    // ----------------------------------------
    // public methods
    initialise(formEle) {
        this.addScript();
        // Add dom element
        const div = document.createElement("div");
        const total = document.querySelectorAll("[turnstile-recaptcha]").length;
        div.setAttribute("turnstile-recaptcha", `${total}`);
        div.id = `${ID}-${total}`;
        formEle.appendChild(div);
        this.instanceID = total;
        // @ts-ignore
        window.onloadTurnstileCallback = () => {
            const recaptchaEles = document.querySelectorAll("[turnstile-recaptcha]");
            recaptchaEles.forEach((ele) => {
                // @ts-ignore
                this.widgetID = turnstile.render(`#${ele.id}`, {
                    sitekey: this.key,
                    callback: (token) => {
                        this.setToken(token);
                    },
                });
            });
        };
    }
    refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            // @ts-ignore
            turnstile.reset(this.widgetID);
            yield this.waitUntilValid();
        });
    }
}
exports.default = Turnstile;
